import React from 'react';
import { Designable } from './Designable.js';
import { isNonEmptyArray } from './utils/array-util.js';
import { isTextChild } from './utils/SmartLayoutUtils.js';
import { useDndMonitor } from '@dnd-kit/core';
import { useAppDispatch } from '../Engine/hooks/hooks.js';
import { setShowDndHint } from '../Engine/store/reducers/enginePropertiesSlice.js';

const SmartLayout = ({ selectedElementIds, handleEdit, handleDelete, handleClone, handleUngroup, onColumnOperation, model, componentList, elementRenderer, getDesignableClassName, engineUpdated, designMode, onEngineClicked }) => {
    const { rootId, componentMap } = model;
    const dispatch = useAppDispatch();
    const dragOverHandler = ({ active, collisions }) => {
        const isEdge = collisions === null || collisions === void 0 ? void 0 : collisions.find((collision) => collision.id === "edge");
        if (isEdge) {
            // Find the closest edge
            const { edge, overId, over } = isEdge.data;
            engineUpdated({
                mode: "edgeHandling",
                data: {
                    edge,
                    overId,
                    active,
                    over
                }
            });
        }
    };
    const dragMoveHandler = ({ active, collisions }) => {
        const isSort = collisions === null || collisions === void 0 ? void 0 : collisions.find((collision) => collision.id === "sort");
        if (isSort) {
            const { overId } = isSort.data;
            engineUpdated({
                mode: "sort",
                data: {
                    overId,
                    active
                }
            });
        }
    };
    const dragEndHandler = ({ active, over, collisions }) => {
        engineUpdated({
            mode: "dragEnd",
            data: {
                active,
                over,
                collisions
            }
        });
    };
    const resetTempState = () => {
        engineUpdated({
            mode: "resetTempState",
            data: {
                active: null,
                over: null,
                collisions: []
            }
        });
    };
    useDndMonitor({
        onDragOver: ({ active, over, collisions }) => {
            if (designMode === "basic")
                return;
            dragOverHandler({ active, collisions });
        },
        onDragMove: ({ over, collisions, active }) => {
            if (designMode === "basic")
                return;
            if (!over &&
                !(collisions === null || collisions === void 0 ? void 0 : collisions.find((item) => item.id === "edge" ||
                    item.id === "createcolumn" ||
                    item.id.split("_temp").length > 1))) {
                resetTempState();
            }
            dragMoveHandler({ active, collisions });
        },
        onDragEnd: ({ active, over, collisions }) => {
            if (designMode === "basic")
                return;
            dragEndHandler({ active, over, collisions });
        }
    });
    const renderDesignMode = (el, index) => {
        if (!el) {
            return null;
        }
        return (React.createElement(Designable, { key: el.id, isSelected: !!selectedElementIds.find(item => item === el.id), multipleSelection: selectedElementIds.length > 1, handleEdit: handleEdit, handleDelete: handleDelete, handleClone: handleClone, handleUngroup: handleUngroup, onColumnOperation: onColumnOperation, meta: el, index: index, componentList: componentList, className: getDesignableClassName(el), designMode: designMode, onEngineClicked: onEngineClicked }, generateVDOM(el)));
    };
    if (Object.keys(componentList).length < 4)
        dispatch(setShowDndHint(true));
    else
        dispatch(setShowDndHint(false));
    const generateVDOM = (component) => {
        if (!component) {
            return null;
        }
        const meta = Object.assign(Object.assign({}, component), { props: Object.assign({}, component.props) });
        let children = [];
        if (isNonEmptyArray(component.children)) {
            children = component.children.map((child, index) => {
                if (isTextChild(child)) {
                    return child.value;
                }
                const id = child.value;
                const element = componentMap[id];
                return renderDesignMode(element, index);
            });
        }
        const renderer = elementRenderer;
        return renderer({ meta, children });
    };
    return generateVDOM(componentMap[rootId]);
};

export { SmartLayout };
//# sourceMappingURL=SmartLayout.js.map
